import { PaymentProviders } from './payment';
import { UserRating } from './rating';

export enum UserMembershipStatus {
  None = 'none',
  Trail = 'trail',
  Churned = 'churned',
  Paying = 'paying',
  Free = 'free',
  Undefined = 'undefined',
}

export type DefaultUserPropsPerEvent = {
  membershipStatus: UserMembershipStatus;
  isActivationElg?: boolean;
  onboaredAt?: string;
  utmSource?: string;
  isChurned: boolean;
  voicesSegments?: string[];
  canUseGuidesForum: boolean;
};

export type UserProps = DefaultUserPropsPerEvent & {
  firstAvailableMeeting?: string;
  firstAttendedMeeting?: string;
  trialEndDate?: string;
  isGuide?: boolean;
  isVoicesPurchase?: boolean;
  isVoicesPurchaseGranted?: boolean;
  voicesPurchaseProductSku?: string;
  voicesPaymentProvider?: PaymentProviders;
  isVoicesRenewed?: boolean;
  guideRating: UserRating | null;
  withinFreeTrial: boolean;
  dateCreated?: Date;
};
